import { render } from "./personal-details.vue?vue&type=template&id=9f962890&scoped=true"
import script from "./personal-details.vue?vue&type=script&lang=js"
export * from "./personal-details.vue?vue&type=script&lang=js"

import "./personal-details.vue?vue&type=style&index=0&id=9f962890&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f962890"]])

export default __exports__